import { Component, Input, OnInit } from '@angular/core';
import { Item } from 'src/app/models/item.model';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-call-entry-item-compromise',
  templateUrl: './call-entry-item-compromise.component.html',
  styleUrls: [
    './../../../../assets/scss/call-screen.scss',
    './call-entry-item-compromise.component.scss'
  ]
})
export class CallEntryItemCompromiseComponent implements OnInit {
  @Input() item: Item;
  @Input() operator: boolean = false;

  constructor(
    private api: MgService
  ) { }

  ngOnInit(): void {
  }

  public toggleEventCompletion(){
    if(!this.operator) return;

    this.api.completeToggleEntry(this.item.id)
      .subscribe(
        res => {
          this.item.is_complete = res.data.is_complete
        }
      )
  }

  public get showName(): string {
    let user = this.item.user.name.split(' ');
    return user[0]
  }

}
